export default "__VITE_ASSET__Bqu8Qiep__"